import { toTitleCase } from '@dirootie-toolbox/strings';

export const colRole = {
  text: "Role",
  dataField: "role",
  formatter: (col: string = "") => toTitleCase(col),
};
